import { render, staticRenderFns } from "./CreateGoodsInfo.vue?vue&type=template&id=27e055fc&scoped=true"
import script from "./CreateGoodsInfo.vue?vue&type=script&lang=js"
export * from "./CreateGoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./CreateGoodsInfo.vue?vue&type=style&index=0&id=27e055fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e055fc",
  null
  
)

export default component.exports